import {useEffect} from 'react';

import {useSelector} from 'react-redux';

import {CUSTOM_DATA, ORDER_COUNTER} from 'constants/analytics/speedCurve';
import {getOrderState} from 'desktop/pages/success/store/selectors/selectors';

/**
 * Tracking conversion.
 */
export function useTrackingConversion() {
    const {status} = useSelector(getOrderState);

    useEffect(() => {
        if (status === 'fulfilled') {
            if (!window.LUX || !window.LUX.addData) return;
            window.LUX.addData(CUSTOM_DATA.ORDER, ORDER_COUNTER);
        }
    }, [status]);
}
